import { Space } from 'antd';
import { HomeControls } from 'components/organisms/HomeControls';
import { RecyclingBinList } from 'components/organisms/ReyclingBinList';

export const RecyclingBinPage = (): JSX.Element => {
  return (
    <Space size={16} direction="vertical">
      <HomeControls />
      <RecyclingBinList />
    </Space>
  );
};
